import { FC, ReactNode } from 'react';

import { Box, Container, ContainerProps, rem } from '@bonusly/design-system';

export const ADMIN_PAGE_WIDTHS = {
	narrow: rem(720),
	standard: rem(960),
	wide: rem(1200),
	full: '100%',
} as const;

type AdminPageWidth = keyof typeof ADMIN_PAGE_WIDTHS;

interface AdminPageContainerProps extends ContainerProps {
	children: ReactNode;
	width?: AdminPageWidth;
	/** Decorative full-bleed layer rendered behind the constrained container (e.g. the Bizy zero-state glow). */
	bleed?: ReactNode;
}

export const AdminPageContainer: FC<AdminPageContainerProps> = ({ children, width = 'standard', bleed, ...props }) => {
	const container = (
		<Container maxW={ADMIN_PAGE_WIDTHS[width]} mx={0} px={10} py={8} position={bleed ? 'relative' : undefined} {...props}>
			{children}
		</Container>
	);

	if (!bleed) {
		return container;
	}

	return (
		<Box position="relative">
			<Box aria-hidden position="absolute" inset={0} pointerEvents="none">
				{bleed}
			</Box>
			{container}
		</Box>
	);
};
